"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _NotificationCenterItemSkeleton = _interopRequireDefault(require("./NotificationCenterItemSkeleton"));

var NotificationCenterSkeleton = function NotificationCenterSkeleton() {
  return (0, _preact.h)("div", {
    className: "notification-center__item--skeleton-wrapper"
  }, (0, _preact.h)(_NotificationCenterItemSkeleton.default, {
    isShown: true
  }), (0, _preact.h)(_NotificationCenterItemSkeleton.default, {
    isShown: true
  }), (0, _preact.h)(_NotificationCenterItemSkeleton.default, {
    isShown: true
  }), (0, _preact.h)(_NotificationCenterItemSkeleton.default, {
    isShown: true
  }), (0, _preact.h)(_NotificationCenterItemSkeleton.default, {
    isShown: true
  }));
};

var _default = NotificationCenterSkeleton;
exports.default = _default;